import React, { useState } from 'react';
import { Sparkles } from 'lucide-react';
import AskNaviPanel from './AskNaviPanel';

// "Ask NAVI about this week" prompt shown below a week's activities.
export default function WeekAskNavi({ programmeId, period, token }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-navigate-gold/25 bg-navigate-gold/5 px-4 py-3" data-testid={`week-ask-navi-${period.period_id}`}>
      <p className="text-sm text-zinc-300">Questions about <span className="text-white">{period.title}</span>? NAVI can explain, give examples or quiz you.</p>
      <button type="button" onClick={() => setOpen(true)} className="flex items-center gap-1.5 px-3.5 py-2 rounded-full bg-navigate-gold text-black text-sm font-medium hover:bg-navigate-gold-light transition-colors" data-testid={`week-ask-navi-btn-${period.period_id}`}>
        <Sparkles className="h-4 w-4" />Ask NAVI about this week
      </button>
      <AskNaviPanel open={open} onOpenChange={setOpen} programmeId={programmeId} period={period} token={token} />
    </div>
  );
}
